import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import '../MobileCustomer/MobileCustomerOverlay'
import { Api } from "../../BackendApi/api";
import MobileConfirmPopup from '../../Component/MobileConfirmPopup/MobileConfirmPopup';


const MobileCustomerOverlay = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    custName: "",
    Custmobile: "",
    coins: 0,
    address: "",
    reference: "",
    referenceId: "",
    custLocation: "",
  });

  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const [showCoinOverlay, setShowCoinOverlay] = useState(false);

  const firstInputRef = useRef(null);

  useEffect(() => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleMapClick = (lat, lng) => {
    setFormData((prev) => ({
      ...prev,
      custLocation: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
    }));
  };

  const handleAddCoin = () => {
    setShowCoinOverlay(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.custLocation || !formData.custLocation.includes(",")) {
      setPopup({
        show: true,
        message: "Please enter valid location in 'lat,lng' format!",
        type: "warning",
      });
      setLoading(false);
      return;
    }

    const requestBody = {
      custName: formData.custName,
      Custmobile: formData.Custmobile,
      coins: parseInt(formData.coins) || 0,
      address: formData.address,
      reference: formData.reference,
      referenceId: formData.referenceId,
      custLocation: formData.custLocation,
    };

    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        setPopup({
          show: true,
          message: "Please login first! Redirecting to login...",
          type: "warning",
        });
        setLoading(false);
        return;
      }

      const response = await axios.post(Api.addCustomer, requestBody, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      if (response.data.status === 0) {
        setPopup({
          show: true,
          message: "Failed to add customer  !",
          type: "error",
        });
      } else {
        setPopup({
          show: true,
          message: response.data.message || "Customer added successfully!",
          type: "success",
        });
      }

    } catch (error) {
      setPopup({
        show: true,
        message: error.response?.data?.message || "Failed to add customer due to network or auth error!",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };

  return (
    <>
      <div className="mobile-overlay">
        <div className="mobile-overlay-content">
          <h2>Add Customer</h2>
          <form className="mobile-overlay-form" onSubmit={handleSubmit}>
            <label className="mobile-custname-label">
              Customer Name
              <div className="mobile-custname-row">
                <input
                  type="text"
                  name="custName"
                  value={formData.custName}
                  onChange={handleChange}
                  required
                  ref={firstInputRef}
                />
              </div>
            </label>

            <label>
              Mobile
              <input
                type="text"
                name="Custmobile"
                value={formData.Custmobile}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Reference ID
              <input
                type="text"
                name="referenceId"
                value={formData.referenceId}
                onChange={handleChange}
                placeholder="Enter Reference ID"
              />
            </label>

            <label>
              Location
              <input
                type="text"
                name="custLocation"
                value={formData.custLocation}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, custLocation: e.target.value }))
                }
                placeholder="Enter Lat,Lng or click map"
                required
              />
            </label>

            <label>
              Address
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </label>

            <label>
              Reference
              <input
                type="text"
                name="reference"
                value={formData.reference}
                onChange={handleChange}
              />
            </label>

            <div className="mobile-overlay-buttons">
              <button type="button" onClick={onClose}>Cancel</button>
              <button type="submit" disabled={loading}>
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>

        <MobileConfirmPopup
          show={popup.show}
          message={popup.message}
          type={popup.type}
          onClose={handlePopupClose}
        />
      </div>

    </>
  );
};

export default MobileCustomerOverlay;
